import React, { useEffect, useState } from "react";
import { allModelsState } from "../components/AllThreeDModels/reduxSlice";
import { useSelector, useDispatch } from "react-redux";
import { Button, Carousel } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { TbArrowBack } from "react-icons/tb";

// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import InterestedForm from "./InterestedForm";

// css
import "./ProductDetails.css";

export const ProductDetails = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { modalsPreview } = useSelector(allModelsState);
  const { productId } = useParams();

  return (
    <>
      <Modal show={show} onHide={handleClose} className="pl-0">
        <Button variant="light" className="close-btn" onClick={handleClose}>
          X
        </Button>
        <InterestedForm />
      </Modal>
      <Swiper
        initialSlide={productId}
        modules={[ Scrollbar, A11y]}
        spaceBetween={0}
        slidesPerView={1}
        onActiveIndexChange={(swiper) => {
          setActiveIndex(swiper.activeIndex);
        }}
        pagination={{ clickable: false }}
        onSwiper={(swiper) => console.log(swiper)}
        onSlideChange={() => console.log("slide change")}
      >
        {modalsPreview.map(({ mobileModal, webModel }, index) => (
          <SwiperSlide>
            <div className="btn-max">
              <span class="switcher switcher-1">
                <input type="checkbox" id="switcher-1" />
                <label for="switcher-1"></label>
              </span>
            </div>
            <div className="max-btnone">
              <button className="btn-pos">I am Interested</button>
            </div>
            <iframe
              className={`w-100 ${
                activeIndex === index ? "d-block" : "d-none"
              } `}
              // src={
              //   window.innerWidth < 480
              //     ? "https://static.digit.in/product/49d9f4f1f9402f3948205dfcb28254c9cf205a23.jpeg?tr=w-1200"
              //     : "https://media.wired.com/photos/5fb2cc575c9914713ead03de/master/w_1920,c_limit/Gear-Apple-MacBook-Air-top-down-SOURCE-Apple.jpg"
              // }
              src={
                activeIndex === index
                  ? window.innerWidth < 480
                    ? mobileModal
                    : webModel
                  : ""
              }
              title="Fan"
            />
            <div className="btn-min">
              <div className="info-btntwo">
                <Link to="/">
                  <button style={{ borderRadius: "15px" }}>
                    <TbArrowBack style={{ fontSize: "26px" }} /> Go back
                  </button>
                </Link>
              </div>
              <div className="info-btntwo">
                <button onClick={handleShow} style={{ borderRadius: "15px" }}>
                  I am Interested
                </button>
              </div>
              <div className="qr-code">
                <img
                  className="qr-code"
                  src="https://media.istockphoto.com/vectors/sample-qr-code-icon-vector-id1164714638?s=612x612"
                  alt="QR-code"
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};
